module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldDisplay) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('logo', {
    attrs: {
      "logoType": "grey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('copyright', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, _vm._l((_vm.footerLinks), function(link) {
    return _c('div', {
      key: link.title,
      staticClass: "footer-link"
    }, [_c('a', {
      attrs: {
        "href": link.href
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t(("ui.footer." + (link.title)))) + "\n        ")])])
  }), 0)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bcfeca9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/AppFooter.vue
// module id = 1952
// module chunks = 0